
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ModalAddQuestion extends Vue {
  @Prop()
  isPublic!: boolean;

  toggleInput = this.isPublic ? this.isPublic : true;

  @Watch('toggleInput')
  toggleInputChange() {
    this.$emit('toggleIsPublic');
  }
}
